<template>
  <section class="case-shows-section">
    <div class="container">
      <h2 class="section-title-zh">{{ $t('caseShows.mainTitleZh') }}</h2>
      <p class="section-title-en">{{ $t('caseShows.mainTitleEn') }}</p>

      <div class="cases-grid">
        <div class="case-item" v-for="(item, index) in caseItems" :key="item.id">
        
          <div class="case-media-wrapper">
           
            <template v-if="playingVideoIndex !== index">
              <div class="case-image-wrapper" @click="playInlineVideo(index, item.videoUrl)">
                <img :src="item.image" :alt="item.altText" class="case-image" />
                <div class="play-icon-overlay">
                  <svg class="play-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"></path>
                  </svg>
                </div>
              </div>
            </template>
            <template v-else>
              <video
                :ref="'videoPlayer-' + index"
                :src="item.videoUrl"
                controls
                autoplay
                preload="auto"
                class="case-video-player"
                @ended="stopInlineVideo(index)"
                @error="handleVideoError(index)"
                @click.stop 
              >
                你的浏览器不支持 HTML5 video 标签。
              </video>
            
              <button
                v-if="playingVideoIndex === index"
                @click.stop="stopInlineVideo(index)"
                class="stop-inline-video-button"
                title="返回缩略图"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="close-icon">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </template>
          </div>
          <p class="case-caption">{{ item.caption }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CaseShows',
  // 不再需要 VideoModal 组件
  // components: {
  //   VideoModal
  // },
  data() {
    return {
      // isModalActive: false, // 不再需要模态框状态
      // currentVideoToPlay: '', // 不再需要模态框视频URL
      playingVideoIndex: null, // 跟踪当前播放视频的索引，null 表示没有视频在播放
    };
  },
 computed: {
  caseItems() {
    const categoryKeys = ['ai', 'tools', 'casualGames', 'shortPlays', 'social', 'finance'];

    return categoryKeys.map((key, index) => {
      let thumbnailPath = '';
      let videoPath = ''; // <--- 新增变量

      try {
        thumbnailPath = require(`@/assets/proimages/${key}.jpg`);
      } catch (e) {
        console.warn(`缩略图未找到: src/assets/proimages/${key}.jpg. 使用占位图。`);
        thumbnailPath = `https://via.placeholder.com/400x225.png?text=${this.$t(`caseShows.categories.${key}`).replace(/\s/g, '+')}`;
      }

      try {
        // 通过 require() 加载视频
        videoPath = require(`@/assets/provideo/${key}.mp4`); // <--- 使用 require()
      } catch (e) {
        console.warn(`视频文件未找到: src/assets/provideo/${key}.mp4.`);
        videoPath = ''; // 或者一个备用的错误提示视频URL
      }

      return {
        id: index + 1,
        image: thumbnailPath,
        caption: this.$t(`caseShows.categories.${key}`),
        altText: this.$t(`caseShows.categories.${key}`) + ' - ' + this.$t('caseShows.playVideo'),
        videoUrl: videoPath // <--- 使用 Webpack 解析后的路径
      };
    });
  }

  },
  methods: {
    playInlineVideo(index, videoUrl) {
      if (!videoUrl) {
        console.warn('尝试播放的视频URL无效或未提供。');
        return;
      }

      // 如果点击的是已经在播放的视频的图片区域 (虽然此时图片不可见，但以防万一)
      if (this.playingVideoIndex === index) {
        // 可以选择重新播放或不做任何事
        const player = this.$refs[`videoPlayer-${index}`];
        if (player && player[0]) {
          player[0].currentTime = 0;
          player[0].play().catch(this.logVideoError);
        }
        return;
      }

      // 如果当前有其他视频在播放，先停止它并切换回图片
      if (this.playingVideoIndex !== null) {
        this.stopInlineVideo(this.playingVideoIndex, false); // false 表示不是因为视频结束而停止
      }

      this.playingVideoIndex = index;

      // 使用 $nextTick 确保 video 元素已被渲染
      this.$nextTick(() => {
        const player = this.$refs[`videoPlayer-${index}`];
        if (player && player[0]) { // refs in v-for are arrays of elements
          player[0].play().catch(error => {
            this.logVideoError(error);
            this.handleVideoError(index); // 如果播放失败，也切换回图片
          });
        } else {
          console.error(`无法找到视频播放器 ref: videoPlayer-${index}`);
          this.handleVideoError(index); // 找不到播放器也切换回图片
        }
      });
    },
    stopInlineVideo(index, videoEnded = true) { // videoEnded 参数用于区分是自然结束还是用户点击停止
      const player = this.$refs[`videoPlayer-${index}`];
      if (player && player[0]) {
        player[0].pause();
        // 可选: 如果不是自然结束，将播放头重置到开始
        if (!videoEnded) {
          // player[0].currentTime = 0;
        }
      }
      // 只有当停止的是当前正在播放的视频时，才重置 playingVideoIndex
      if (this.playingVideoIndex === index) {
        this.playingVideoIndex = null;
      }
    },
    handleVideoError(index) {
      console.error(`视频加载或播放错误: ${this.caseItems[index] ? this.caseItems[index].caption : '未知项目'}`);
      // 发生错误时，也切换回图片状态
      if (this.playingVideoIndex === index) {
          this.playingVideoIndex = null;
      }
    },
    logVideoError(error) {
      if (error.name === 'NotAllowedError') {
        console.warn('视频自动播放被浏览器阻止。用户可能需要先与页面交互。');
      } else {
        console.error('视频播放时发生错误:', error);
      }
    }
    // 不再需要 showVideoModal 和 hideVideoModal
  }
};
</script>

<style scoped>
/* 大部分样式保持不变，但需要为新的包裹层和视频播放器调整 */
.case-shows-section {
  padding: 80px 0 100px;
  background-color: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title-zh {
  font-size: 2.8em;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 8px;
  font-weight: 700;
  line-height: 1.2;
}

.section-title-en {
  font-size: 1.1em;
  color: #007bff;
  text-align: center;
  margin-top: 0;
  margin-bottom: 60px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.case-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* 新的 .case-media-wrapper，用于容纳图片或视频 */
.case-media-wrapper {
  position: relative; /* 用于绝对定位停止按钮 */
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 16px; /* 增大圆角 */
  margin-bottom: 20px;
  background-color: #111; /* 深色背景，视频通常看起来更好 */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); /* 加深初始阴影 */
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.case-item:hover .case-media-wrapper {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.case-image-wrapper {
  /* 这个 wrapper 现在只包裹图片和播放图标 */
  position: relative; /* 如果内部还有绝对定位元素，则需要 */
  width: 100%;
  height: 100%; /* 确保它填满 .case-media-wrapper */
  cursor: pointer;
  display: flex; /* 用于垂直居中播放按钮（如果需要） */
  align-items: center;
  justify-content: center;
}

.case-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.case-image-wrapper:hover .case-image {
  transform: scale(1.05);
}

.play-icon-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0; /* 默认隐藏 */
  transition: all 0.4s ease;
}

.case-image-wrapper:hover .play-icon-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 1; /* 悬浮时显示 */
}

.play-icon {
  width: 60px; /* 加大播放按钮 */
  height: 60px;
  color: white;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.5));
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform: scale(0.8); /* 初始缩小 */
}

.case-image-wrapper:hover .play-icon {
  transform: scale(1); /* 悬浮恢复原大小 */
}

.case-video-player {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 0; /* 视频通常不需要圆角，除非设计要求 */
  object-fit: contain; /* 或者 'cover'，取决于你希望视频如何填充 */
}

.stop-inline-video-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%; /* 圆形按钮 */
  width: 32px;
  height: 32px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10; /* 确保在视频控件之上 */
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.stop-inline-video-button:hover {
  background-color: rgba(0, 0, 0, 0.85);
  transform: scale(1.1);
}

.close-icon {
  width: 18px;
  height: 18px;
}


.case-caption {
  font-size: 1.15em;
  color: #1a1a2e;
  margin-top: 5px;
  font-weight: 600;
  transition: color 0.3s ease;
}

.case-item:hover .case-caption {
  color: #007bff;
}

@media (max-width: 768px) {
  /* ... 省略，与之前相同 ... */
  .cases-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }
  .section-title-zh {
    font-size: 2em;
  }
  .section-title-en {
    font-size: 1.1em;
  }
}

@media (max-width: 480px) {
  /* ... 省略，与之前相同 ... */
  .cases-grid {
    grid-template-columns: 1fr;
  }
   .play-icon {
    width: 40px;
    height: 40px;
  }
  .case-caption {
    font-size: 0.9em;
  }
  .stop-inline-video-button {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    top: 5px;
    right: 5px;
  }
}
</style>